import { BaseModal, Button, Input, Multiselect } from '@cokitchen/cokitchen-components';
import React, { FC, ReactNode, useState } from 'react';
import { ReactComponent as TitleIcon } from 'assets/icons/update-surge-modal-icon.svg';

type UnResolveModalProps = {
  show: boolean;
  type?: 'resolved' | 'unresolved';
  children?: ReactNode;
  onClose: (refetchData?: boolean) => void;
};

interface UnResolveModalFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const UnResolveFooterProps: FC<UnResolveModalFooterProps> = ({ onConfirm, loading }) => (
  <div>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      // disabled={disabled}
      onClick={onConfirm}>
      Mark as Resolved
    </Button>
  </div>
);

const UnresolvedModal: FC<UnResolveModalProps> = ({ show, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [selectRole, setSelectRole] = useState<string[]>([]);

  const resolveModal = () => {
    setLoading(true);
  };

  const ISSUE_SOURCE_OPTIONS = [
    { text: 'Jollof & cos.', value: 'KITCHEN' },
    { text: 'Jollof & co.', value: 'DELIVERY' },
    { text: 'Jollof & coss.', value: 'REVIEW' }
  ];

  return (
    <div className='relative'>
      <BaseModal
        isOpen={show}
        title=''
        titleIcon={<TitleIcon />}
        titleIconColor='info'
        onRequestClose={() => onClose()}
        footer={
          <UnResolveFooterProps
            loading={loading}
            onCancel={() => onClose()}
            onConfirm={resolveModal}
          />
        }>
        <div className='absolute left-44 top-8'>
          <div className='flex gap-[7px] items-center'>
            <p className='font-semibold text-[#1A1A1A] text-[20px]'>#26AB56</p>
            <p className='text-xs border border-red-4 px-[10px] rounded-[40px] bg-[#FEE7EA] text-red-3'>
              Unresolved
            </p>
          </div>
        </div>

        <div className=' text-[14px h-[400px] text-[#1A1A1A] px-3 pt-5'>
          <div className='flex justify-between border-[#EAEBEB] border-b pb-[7px]'>
            <p className='text-[#858585]'>Name</p>
            <p>Adebayo Micheal</p>
          </div>

          <div className='flex justify-between border-[#EAEBEB] border-b py-[20px]'>
            <p className='text-[#858585]'>CS Rep Assigned</p>
            <p>Adebayo Micheal</p>
          </div>

          <div className='flex justify-between border-[#EAEBEB] border-b py-[20px]'>
            <p className='text-[#858585]'>Issue</p>
            <p className='w-[75%] text-right'>
              Proin nam ac lectus pharetra. Venenatis pretium magna cursus arcu felis non
              vestibulum. Dignissim augue sem enim montes mauris cursus.
            </p>
          </div>

          <div className='flex justify-between border-[#EAEBEB] border-b py-[20px]'>
            <p className='text-[#858585]'>Category</p>
            <p>Review</p>
          </div>

          <div className='flex justify-between border-[#EAEBEB] border-b py-[20px]'>
            <p className='text-[#858585]'>Resolved by</p>

            <Multiselect
              placeholder='Select role'
              values={selectRole}
              options={ISSUE_SOURCE_OPTIONS}
              onChange={setSelectRole}
              isSingle
            />
          </div>

          <div className='flex justify-between border-[#EAEBEB] border-b py-[20px]'>
            <p className='text-[#858585]'>Resolution</p>

            <div>
              <Input
                name='resolution'
                small
                inputClass='placeholder:text-sm'
                className='text-[14px] '
                placeholder='How it was resolved '
              />
            </div>
          </div>

          <div className='flex justify-between border-[#EAEBEB] border-b py-[20px]'>
            <p className='text-[#858585]'>Date </p>
            <p className='text-[#595959]'>10th Jul, 2023, 12:32PM</p>
          </div>
        </div>
      </BaseModal>
    </div>
  );
};

export default UnresolvedModal;
